/*
* PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
* Copyright (c) 2019 Pearson Education, Inc.
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains the property of
* Pearson Education, Inc. The intellectual and technical concepts contained
* herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
* and Foreign Patents, patent applications, and are protected by trade secret
* or copyright law. Dissemination of this information, reproduction of this
* material, and copying or distribution of this software is strictly forbidden
* unless prior written permission is obtained from Pearson Education, Inc.
*/
import React, { Component } from 'react'
import { func, string, array, number, bool, object } from 'prop-types'
import FileUpload from './components/FileUploader'
import { UploaderProvider } from './containers/UploaderContext'

/**
 * ### Import
 * ```js
 * import FileUpload from '@pearson-learning-apps-shared-components/webcomponents'
 *
 * const FileUpload = FileUpload.FileUploader
 * ```
 */
class FileUploader extends Component {
  render () {
    return (
      <UploaderProvider>
        <FileUpload {...this.props} />
      </UploaderProvider>
    )
  }
}

FileUploader.propTypes = {
  uploadLabel: string.isRequired, // label above the component
  buttonLabel: string, // label for the browse button
  handleChange: func, // function to fully handle the file upload for drop or file change
  allowedFileTypes: array, // array of file types allowed.  Used for confirming the extension is correct
  id: string, // unique id
  filesAllowedLabel: string, // message to the user for the files allowed
  errorLoadingErrorMessage: string, // error message if the file is incorrect. Shown inline
  updateFile: func, // used if the file is parsed, will update parent
  maxFileSizeBytes: number, // maximum file size allowed for this
  maxFileTypeSizeBytes: object, // maximum file size allowed for different file types
  allowedFileSizeText: string, // maximum file size limit message
  allowedFileTypeText: string, // third guide text for all file types
  onAnyChange: func,
  isSingleFileUpload: bool,
  hideRemoveButton: bool
}

FileUploader.defaultProps = {
  uploadLabel:'Upload file',
  buttonLabel: 'Browse',
  id:'regionQuestion',
  allowedFileTypes: ['.gif', '.jpg', '.png', '.jpeg'],
  hideRemoveButton: false

}
export default FileUploader
